module.exports = __webpack_public_path__ + "media/background-cogir.mp4";